<div class="tab-pane active container-fluid pt-4" role="tabpanel" aria-labelledby="dataset-tab">
	<div class="float-end">
		<button class="btn btn-info" jhiTranslate="study.details.datasets.export" *jhiHasAnyAuthority="MANAGE_STUDIES_PERMISSIONS"
				(click)="exportDataset()">
		</button>
	</div>
	<jhi-collapsible heading="{{translateService.instant('study.details.datasets.traits.title')}}" [isCollapsed]="true" *ngIf="isObservationOrSubObservationDataset()" img="content/img/baseline-traits.png">
		<div class="container-fluid mb-4 ps-0">
			<div class="row">
				<div class="col-6">
					<table class="table table-striped table-bordered table-curved" *ngIf="getTraits().length else traitsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.table.name"></span></th>
							<th><span jhiTranslate="study.details.table.description"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let trait of getTraits()">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: trait.termId }">{{ observationVariableHelperService.getVariableDisplayName(trait) }}</a></td>
							<td>{{trait.description}}</td>
						</tr>
						</tbody>
					</table>
					<ng-template #traitsNoData>
						<span jhiTranslate="study.details.datasets.traits.no-data"></span>
					</ng-template>
				</div>
			</div>
		</div>
	</jhi-collapsible>

	<h4 *ngIf="isObservationOrSubObservationDataset()" class="fw-bold mb-3" jhiTranslate="study.details.datasets.observations.title">>OBSERVATIONS</h4>

	<div class="row">
		<div class="col">
			<div class="mb-3 d-flex align-items-center">
				<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
				<span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
			</div>
		</div>
	</div>

	<div class="table-responsive" *ngIf="header && observations">
		<table class="table table-striped table-bordered table-curved" *ngIf="header.length else nodata">
			<thead>
			<tr>
				<th *ngFor="let column of header" [ngClass]="{ 'factors': column.factor }">
                    @if (getStaticColumnLabelKey(column.termId)) {
                        {{ getStaticColumnLabelKey(column.termId) | translate }}
                    } @else {
                        {{ observationVariableHelperService.getVariableDisplayName(column) }}
                    }
				</th>
			</tr>
			</thead>
			<tbody *ngIf="observations.length">
			<tr *ngFor="let observation of observations; trackBy: trackId; index as index">
				<td *ngFor="let column of header">
                    <div *ngIf="hasObservationMultiValues(column.termId) else singleValue">
                        <span *ngIf="!this.observation.variables[column.name].values || this.observation.variables[column.name].values.length === 0"> - </span>
                        <span *ngIf="this.observation.variables[column.name].values">
                            <span *ngFor="let value of this.observation.variables[column.name].values; let last = last; let first = first; let idx = index;">
               				    {{(first && this.observation.variables[column.name].values.length) > 1 ? '[' : ''}}
                                <a *ngIf="value !== 'UNKNOWN'" (click)="$event.stopPropagation()"
                                   [routerLink]="['/', { outlets: { popup: 'germplasm-details-dialog/' + this.parentGID(column, this.observation.variables, idx)} }]"
                                   queryParamsHandling="merge"><truncate-span [textInput]="value"></truncate-span></a>
                                <a *ngIf="value === 'UNKNOWN'">{{value}}</a>
                                {{(last && this.observation.variables[column.name].values.length > 1) ? ']' : ''}} {{last ? '' : ','}}
                            </span>
                        </span>
                    </div>
                    <ng-template #singleValue>
                        <span *ngIf="showViewGermplasmDetailsLink(column.termId) else nolink">
                            <a class="link" (click)="germplasmDetailsPopupService.open( this.observation.gid )">
                                <truncate-span [textInput]="getObservationByVariable(column, index)" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                            </a>
                        </span>
                        <ng-template #nolink>
                            <truncate-span [textInput]="getObservationByVariable(column, index)" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                        </ng-template>
                    </ng-template>

                </td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>

	<div *ngIf="observations?.length" class="row pb-4">
		<div class="col">
			<div class="pagination-container">
				<div class="pagination-box pagination-box-left">
					<div>
						<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
					</div>
				</div>
				<div class="pagination-box">
					<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
									[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
				</div>
				<div class="pagination-box pagination-box-right">
					<div class="d-flex align-items-center">
						<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
						<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
							<option value="20">20</option>
							<option value="50">50</option>
							<option value="75">75</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
